import Grid  from "../GridComponent/Grid"
import React, { useEffect, useState } from "react"
import { getNumberFormatter, NumberFormats } from '@superset-ui/number-format'
import { getTimeFormatter, TimeFormats } from '@superset-ui/time-format'
import axios from 'axios';
import Loading from '../LoadingComponent/Loading'
import './SecondTab.css'
// import TestsGridComponent from "../TestsGridComponent/TestsGridComponent";

const apiService = axios.create({
  baseURL: 'https://api.hom.edat.unicamp.br/superset',
  // baseURL: 'https://api.dados.unicamp.br/superset',
});

function SecondTab(props) {
  const [data, setData] = useState([]);
  const [error, setError] = useState('');
  const [removeLoading, setRemoveLoading] = useState(false)

  // useEffect block
  useEffect(() => {
    apiService.get("/getCharts/" + props.dashboard_id)
        .then((res) => {
          return res.data;
        })
        .then((data) => {

          let _graphData = []
          data.forEach((item, index) => {
            // obtem label das colunas (title) e nome dos campos (field)
            const _cols = Object.keys(item.labels).map(property => {
              const sourceProperty = String(property).replace(/\./g, '');
              return { title: item.labels[property][0], field: sourceProperty }
            });

            const formatos = item['formatos']
            const formatado = item['dados'].map((dados) => {
              const obj = {}
              Object.keys(dados).forEach((key, index) => {
                const sourceKey = String(key).replace(/\./g, '')
                // console.log(index, key, dados[key])
                // console.log(formatos)
                let format = undefined
                if (formatos.length > 1) {
                  if (formatos[index] !== undefined) {
                    format = formatos[index][key]
                  }
                } else {
                  if (formatos[0] !== undefined) {
                    format = formatos[0][key]
                  }
                }

                if (format !== undefined) {
                  let formatter
                  switch (format) {
                    case ',.1%':
                      formatter = getNumberFormatter(NumberFormats.PERCENT_1_POINT)
                      break
                    case ',.2%':
                      formatter = getNumberFormatter(NumberFormats.PERCENT_2_POINT)
                      break
                    case 'smart_date':
                      // se a string de data tem 4 dígitos ou menos, assumimos que é um ano ou um dado numérico
                      // se a string contém letras, assumimos que é uma palavra ou frase
                      if (/^\d{1,4}$/.test(dados[key]) || /[a-zA-Z]/.test(dados[key])) {
                        formatter = (str) => { return str }
                      } else {
                        formatter = getTimeFormatter(TimeFormats.US_DATE)
                      }
                      break
                    default:
                      formatter = getNumberFormatter(format)
                  }
                  if (formatter !== undefined && dados[key] !== null && dados[key] !== undefined) {
                    obj[sourceKey] = formatter(dados[key])
                  } else {
                    obj[sourceKey] = 'N/A'
                  }
                } else {
                  obj[sourceKey] = dados[key]
                }
              })
              return obj
            })

            const itemObj = {
              "name": item.nome,
              "data": formatado,
              "cols": _cols
            }
            _graphData.push(itemObj)
          })
          // console.log("Dados do gráfico: ")
          // _graphData.forEach(item => {
          //   console.log(item)
          // })
          setData(_graphData)
          setRemoveLoading(true)
        }).catch(err => {
      setError(err.message)
      console.log(err)
    });
  }, []);

  return (
    <div className="SecondTab">
      {error && (
        <p className="text-danger">{error}</p>
      )}
      {data.length > 0 && (
        <div>
          {data.map((item) => (<Grid name={item.name} data={item.data} cols={item.cols}></Grid>))}
        </div>
      )}
      {/*<TestsGridComponent></TestsGridComponent>*/}
      {!removeLoading &&
        <div className="loading">
          <Loading/>
        </div>
      }
    </div>
  )
};
export default SecondTab;
